import { Entity } from '@core/entities/entity'
import { IPermitStatsByStatus } from './IPermitStatsByStatus'
import { plainToInstance } from 'class-transformer'
import { PermitStatus } from '@core/entities/permit/PermitBase/types'

export class PermitStatsByStatus extends Entity<IPermitStatsByStatus> {
  status: PermitStatus

  count: number

  public static new(payload: unknown): PermitStatsByStatus {
    const entity = plainToInstance(PermitStatsByStatus, payload)

    return entity
  }
}
